/**
 * Signals sent TO the extension (from Angular app)
 */
export enum AsmtRunnerSend {
    VRETTA_ACTIVATE_REQUEST           = 'VRETTA_ACTIVATE_REQUEST',
    VRETTA_ACTIVATE_ASSESSMENT_LOCK   = 'VRETTA_ACTIVATE_ASSESSMENT_LOCK',
    VRETTA_DEACTIVATE_REQUEST         = 'VRETTA_DEACTIVATE_REQUEST',
    VRETTA_DEACTIVATE_ASSESSMENT_LOCK = 'VRETTA_DEACTIVATE_ASSESSMENT_LOCK',
    VRETTA_ASSESSMENT_LOCK_PING       = 'VRETTA_ASSESSMENT_LOCK_PING',
    VRETTA_VERIFIED_ACCESS_SIGNING_STATUS_REQUEST = 'VRETTA_VERIFIED_ACCESS_SIGNING_STATUS_REQUEST',
    VRETTA_VERIFIED_ACCESS_SIGN_REQUEST = 'VRETTA_VERIFIED_ACCESS_SIGN_REQUEST',
    /** Extension uses this to set UI language; falls back to English when absent (e.g. ABED). */
    VRETTA_ASSESSMENT_LOCK_SET_LANGUAGE = 'VRETTA_ASSESSMENT_LOCK_SET_LANGUAGE',
}

/**
 * Signals received FROM the extension (to Angular app)
 */
export enum AsmtRunnerReceive {
    VRETTA_ASSESSMENT_LOCK_ACTIVATED                = 'VRETTA_ASSESSMENT_LOCK_ACTIVATED',
    VRETTA_ASSESSMENT_LOCK_DEACTIVATED              = 'VRETTA_ASSESSMENT_LOCK_DEACTIVATED',
    VRETTA_ASSESSMENT_LOCK_ACTIVATION_FAILED        = 'VRETTA_ASSESSMENT_LOCK_ACTIVATION_FAILED',
    VRETTA_ASSESSMENT_LOCK_DEACTIVATION_FAILED      = 'VRETTA_ASSESSMENT_LOCK_DEACTIVATION_FAILED',
    VRETTA_ASSESSMENT_LOCK_PONG                     = 'VRETTA_ASSESSMENT_LOCK_PONG',
    VRETTA_EXTENSION_CONTEXT_INVALIDATED            = 'VRETTA_EXTENSION_CONTEXT_INVALIDATED',
    VRETTA_VERIFIED_ACCESS_SIGNING_STATUS_RESPONSE      = 'VRETTA_VERIFIED_ACCESS_SIGNING_STATUS_RESPONSE',
    VRETTA_VERIFIED_ACCESS_SIGNED                   = 'VRETTA_VERIFIED_ACCESS_SIGNED',
    VRETTA_VERIFIED_ACCESS_FAILED                   = 'VRETTA_VERIFIED_ACCESS_FAILED',
}

/**
 * Extension status states
 */
export enum ExtensionStatus {
    CHECKING = 'checking',
    CONNECTED = 'connected',
    NOT_RESPONDING = 'not_responding',
    CONTEXT_INVALIDATED = 'context_invalidated',
    NOT_INSTALLED = 'not_installed',
}

/**
 * Extension state interface
 */
export interface AssessmentLockState {
    isLockdown: boolean;
    triggerUrl: string | null;
    triggerTabId: number | null;       // Current trigger tab ID (changes on restoration)
    previousTabIds: number[];          // History of destroyed tabs (security monitoring)
    extensionStatus: ExtensionStatus;
}
